import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { FLOATING_CATEGORY_NAV_HEIGHT } from '../../../shared/public/constants/layout.constants';

export type EditorialBandGround = 'cream' | 'plain' | 'tint' | 'solid';

interface EditorialBandProps {
  ground?: EditorialBandGround;
  /** Réserve la hauteur de la barre de catégories flottante. À poser sur la première bande d'une page. */
  underFloatingNav?: boolean;
  children: React.ReactNode;
}

// La bande porte le fond sur toute la largeur, et recentre son contenu dans la même colonne que le
// reste du site. Séparer les deux évite le réflexe du fond posé sur un conteneur déjà borné, qui
// laisse des gouttières blanches sur les grands écrans.
const useStyles = makeStyles((theme) => ({
  band: {
    width: '100%',
    padding: '2.5rem 1rem',

    [theme.breakpoints.up('md')]: {
      padding: '4rem 1.5rem',
    },
  },
  cream: {
    backgroundColor: '#FAF6EC',
  },
  plain: {
    backgroundColor: '#fff',
  },
  tint: {
    backgroundColor: theme.palette.client.primary.extraLight,
  },
  solid: {
    backgroundColor: theme.palette.client.primary.main,
    color: '#fff',
  },
  // La barre de catégories ne flotte que sur desktop : sur mobile, les catégories sont dans le
  // drawer, donc rien ne survole la page et il n'y a aucune hauteur à réserver.
  underFloatingNav: {
    [theme.breakpoints.up('md')]: {
      paddingTop: FLOATING_CATEGORY_NAV_HEIGHT + 32,
    },
  },
  inner: {
    maxWidth: 1120,
    margin: '0 auto',
  },
}));

const EditorialBand: React.FC<EditorialBandProps> = ({ ground = 'plain', underFloatingNav = false, children }) => {
  const classes = useStyles();

  return (
    <section
      className={`${classes.band} ${classes[ground]} ${underFloatingNav ? classes.underFloatingNav : ''}`}
    >
      <div className={classes.inner}>{children}</div>
    </section>
  );
};

export default EditorialBand;
